import { Component, Input } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { Observable } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'sm-dac-details',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  providers: [DatePipe],
  template: `
    <div *ngIf="dacDetails$ | async as dac" class="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 w-full mb-4">
      <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">{{ 'clarification.reports.form.dac_details.title' | translate }}</h3>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="flex flex-col">
          <span class="text-sm font-medium text-gray-500 dark:text-gray-400">{{ 'clarification.reports.form.dac_details.reference_dac' | translate }}</span>
          <span class="text-base text-gray-900 dark:text-gray-200">{{ dac.referenceDac || '-' }}</span>
        </div>
        <div class="flex flex-col">
          <span class="text-sm font-medium text-gray-500 dark:text-gray-400">{{ 'clarification.reports.form.dac_details.reference_ao' | translate }}</span>
          <span class="text-base text-gray-900 dark:text-gray-200">{{ dac.aoReference || '-' }}</span>
        </div>
        <div class="flex flex-col">
          <span class="text-sm font-medium text-gray-500 dark:text-gray-400">{{ 'clarification.reports.form.dac_details.ppm' | translate }}</span>
          <span class="text-base text-gray-900 dark:text-gray-200">{{ dac.ppmNom || '-' }}</span>
        </div>
        <div class="flex flex-col">
          <span class="text-sm font-medium text-gray-500 dark:text-gray-400">{{ 'clarification.reports.form.dac_details.realisations' | translate }}</span>
          <span class="text-base text-gray-900 dark:text-gray-200">{{ dac.realisationEnvisagees || '-' }}</span>
        </div>
        <div class="flex flex-col">
          <span class="text-sm font-medium text-gray-500 dark:text-gray-400">{{ 'clarification.reports.form.dac_details.type_marche' | translate }}</span>
          <span class="text-base text-gray-900 dark:text-gray-200">{{ dac.typeMarche || '-' }}</span>
        </div>
        <div class="flex flex-col">
          <span class="text-sm font-medium text-gray-500 dark:text-gray-400">{{ 'clarification.reports.form.dac_details.mode_passation' | translate }}</span>
          <span class="text-base text-gray-900 dark:text-gray-200">{{ dac.modePassationLibelle || '-' }}</span>
        </div>
        <div class="flex flex-col">
          <span class="text-sm font-medium text-gray-500 dark:text-gray-400">{{ 'clarification.reports.form.dac_details.date_soumission' | translate }}</span>
          <span class="text-base text-gray-900 dark:text-gray-200">
            {{ dac.dateLimiteSoumission ? (dac.dateLimiteSoumission | date:'dd/MM/yyyy HH:mm') : '-' }}
          </span>
        </div>
        <div class="flex flex-col">
          <span class="text-sm font-medium text-gray-500 dark:text-gray-400">{{ 'clarification.reports.form.dac_details.date_reception' | translate }}</span>
          <span class="text-base text-gray-900 dark:text-gray-200">
            {{ dac.dateLimiteReception ? (dac.dateLimiteReception | date:'dd/MM/yyyy HH:mm') : '-' }}
          </span>
        </div>
      </div>
    </div>
  `
})
export class DacDetailsComponent {
  @Input() dacDetails$!: Observable<any>;
}
